export default "__VITE_ASSET__87ae39ab__"